import {Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {NoContentComponent} from './no-content.component';

export const ROUTES: Routes = [
  { path: '', component: LoginComponent },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    // loadChildren: './home/home.module#HomeModule',
    data: { preload: true }
  },
  {
    path: 'home-ng',
    loadChildren: () => import('./home/home.module.ng').then(m => m.HomeModuleNG),
    //loadChildren: './home/home.module.ng#HomeModuleNG',
    data: { preload: true }
  },
  {
    path: 'home-concept',
    loadChildren: () => import('./home/home.concept.module').then(m => m.HomeConceptModule),
    // loadChildren: './home/home.concept.module#HomeConceptModule',
    data: { preload: true }
  },
  {
    path: 'home-with-menus',
    loadChildren: () => import('./home/home-with-menus.module').then(m => m.HomeWithMenusModule),
//    loadChildren: './home/home-with-menus.module#HomeWithMenusModule',
    data: { preload: true }
  },
  {
    path: 'halfGod',
    loadChildren: () => import('./halfGod/half.module').then(m => m.HalfGodModule),
    // loadChildren: './halfGod/half.module#HalfGodModule',
    data: { preload: true }
  },
  {
    path: 'demo',
    loadChildren: () => import('./home/home.demo.module').then(m => m.HomeDemoModule),
    //loadChildren: './home/home.demo.module#HomeDemoModule',
    data: { preload: true }
  },
  // { path: 'home',  component: HomeComponent },
  // { path: 'about', component: AboutComponent },
  // { path: 'detail', loadChildren: './+detail#DetailModule'},
  // { path: 'barrel', loadChildren: './+barrel#BarrelModule'},
  { path: '**',    component: NoContentComponent },
];
